import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { deleteAAGroup, deleteUser } from "../../../apiclients/streamsapi_bridge.js";

const DeleteAAGroup = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  // const [isloading, setIsloading] = useState(false);
  async function removeThisGrp(e) {
    props.setIsloading(true);
    console.log(props.group.code);
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    let deleteGrp = await deleteAAGroup(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      props.group.code
    );
    setTimeout(() => {
      props.setIsloading(false)
    }, 1000);
    let deleteMsg = await deleteGrp.json();
    console.log("Response... ");
    console.log(deleteMsg);
    if (deleteMsg.status == "success") {
      localStorage.setItem("s_message", "Auto-Attendant group removed successfully.");
      window.location.href = "/autoattendant";

    } else {
      localStorage.setItem(
        "f_message",
        deleteMsg.message
      );
      props.onClose();
      window.location.href = "/autoattendant";
    }
  }
  return (
    <>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
      {props.assocCFData && props.assocCFData.length > 0 && (
        <>
          <div>
            <span className="phrecording">{t("associated_cflows")}<br />{props.assocCFData?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()} </span>
          </div>

          <div style={{ display: "none" }}>
            <button ref={ref} onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              props.onClose();
            }}>
              {t("okay")}</button>
          </div>
        </>

      )}
      {props.assocCFData.length == 0 && (
        <>

          <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
            <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
            <span>{t("RemoveAutoAttendentGroup")}</span>
          </div>

          <div style={{ display: "none" }}>
            <button ref={ref} onClick={(e) => removeThisGrp(e)}>
              {t("remove")}</button>
          </div>
        </>
      )}

      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => removeThisGrp(e)}>{t("remove")}</MDBBtn>
      </MDBModalFooter> */}
    </>
  );
});

export default DeleteAAGroup;
